import { render } from "./AllowReactions.vue?vue&type=template&id=e211ec7e"
import script from "./AllowReactions.vue?vue&type=script&lang=js"
export * from "./AllowReactions.vue?vue&type=script&lang=js"

import exportComponent from "/working_dir/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__